import React from 'react'
import { ChampionshipStack } from './stacks'

import { GenericItem } from './generic'

export const ChampionshipItem = props => {
  return <GenericItem {...props} StackComponent={ChampionshipStack} />
}
